












































import settings from '@/settings.coffee'
import queries from "@/gql/queries.coffee"
import tools from "@/tools.coffee"
import EstablishmentLogo from "@/components/EstablishmentLogo.vue"
import filters from "@/filters.coffee"

export default {
    "name": 'EstablishmentHome'
    "components": {EstablishmentLogo}
    "computed":
        "hero_style": ()->
            background_image = filters.filters.as_css_background(@staff.establishment.main_picture)
            console.log("back", background_image)
            return {
                "background-image": background_image["background-image"],
                "background-size": "cover"
            }
        "content_style": ()->
            return {
                "background-color": "#eee"
            }
    "data": ()->
        return {
            "staff": null
            "reviews": {}
            "reviews_count": 0
        }
    "methods":
        "logout": ()->
            this.$http.get(settings.authApiUrlLogout)
            .then ()->
                location.reload()
        "fetch_data": ()->
            self = @
            r = await queries.run("get_staff_establishment", [@$store.state.profile.data.uid])
            if r.ok
                @staff = r.body.data.establishment_staff
                console.log("establishment", @staff.establishment)

                # get the reviews using notifications
                r2 = await queries.run("get_sent_notifications_for_establishment", [@staff.establishment.uid])
                console.log(r2)
                if r2.ok
                    reviews = {}
                    for notification in r2.body.data.email_set
                        console.log("notification", notification)
                        review = notification.state.review
                        # we keep only notifications for current state
                        if notification.state.uid == review.current_state.uid
                            if review.current_state.class_name in ["InformationNeeded", "AnswerWriting", "SignalingWriting", "SignalingSent"]
                                console.log("keep !", review.uid)
                                reviews[review.uid] = review
                                self.reviews_count += 1
                    self.reviews = reviews
    "created": ()->
        self = @
        await self.fetch_data()
        console.log("reviews", self.reviews)
        self.$djangows['onmodelsignals'] {"modelName": "email", "appLabel": "core"}, (event)->
            console.log("email", event)
            # if event.obj.establishment == self.staff.establishment.uid
        #         console.info("I take this event !", event)
        #         self.fetch_data()
            #     console.log("state event", event)
            #     self.fetch_data()
            #
            # if event.deleted
            #     console.log("deleted")
            # else
            #     if event.created
            #         console.log("created")
            #     else
            #         console.log("updated")
            # if event.obj?
            #     if event.obj.state == self.state.uid
            #         self.fetch_data()
            # else
            #     if event.obj.state == self.state.uid
            #         if event.message == "deleted"
            #             self.fetch_data()
        # )
}
